import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import HeroImg from '../../Shared components/HeroImg';
import { MdArrowBackIosNew } from 'react-icons/md';
import setImageimg from '../../imgs/setImage.png';
import { MdAddCircle } from "react-icons/md";
import usePersonStore from '../../context/RegisterContext';
import { Trainee } from '../../types/user';
import { useStore } from 'zustand';
import { stat } from 'fs';
import toast, { Toaster } from 'react-hot-toast';
const ChooseImage = () => {
    const { role } = useParams();
    const required = role === "Trainer";
    const [img, setImg] = useState<File | null>(null);
    const navigate = useNavigate();
    const updateImage = usePersonStore((state) => state.setImage);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setImg(file);
            updateImage(file);
        }
    };


    const handleContinue = () => {
        if (img && role == "trainer") {

            updateImage(img);
            navigate(`/register/${role}`);
        } else if (role == "trainer" && !img) {
            toast.error("يجب اضافة صورة شخصية")
        }
        else if (role != "trainer") {
            navigate(`/register/${role}`);
        }

        // Navigate to the next step

    };
    return (
        <>
            <Toaster />
            <div className='md:h-screen w-full mb-10 md:my-0'>
                <div className="flex flex-row min-h-screen w-full">
                    <HeroImg />
                    <div className="flex flex-col items-end justify-start w-full mt-10 px-24 relative">
                        <button onClick={() => navigate(`/`)}>
                            <div className='w-[40px] h-[40px] border absolute top-0 left-0 cursor-pointer ml-6 border-neutral-800 rounded-full flex justify-center items-center hover:bg-primary-100 transition-all duration-150 group'>
                                <MdArrowBackIosNew
                                    size={22}
                                    color='#4a4a4a'
                                    fontWeight={200}
                                    className="text-neutral-900 group-hover:translate-x-[-2px] group-hover:fill-white transition-transform duration-150"
                                />
                            </div>
                        </button>
                        <div>
                        </div>
                        <div>
                            <div className="w-full flex justify-end">
                                <h2 className="text-[32px] leading-[67.58px] font-[500] text-neutral-900 flex flex-col md:flex-row-reverse items-end">  مرحباً بكم في <div className='mr-2'>Otlob Coach</div></h2>
                            </div>
                            <div className="w-full flex justify-end">
                                <p className="text-[16px] leading-[24px] font-[400] text-neutral-900">هل لديك حساب بالفعل؟<span className="underline mr-1"> <a href="/login">تسجيل الدخول</a></span></p>
                            </div>
                        </div>
                        <div className='flex flex-col items-center justify-center w-full mt-10'>
                            <div>
                                <h2 className="text-[32px] leading-[67.58px] font-[600] text-neutral-900"> اضف صورة شخصية </h2>
                            </div>
                            <div className="flex flex-col items-center justify-start w-full">
                                <div className='mt-10 relative group overflow-hidden rounded-full'>
                                    <img
                                        src={img ? URL.createObjectURL(img) : setImageimg}
                                        className='w-[120px] h-[120px] rounded-full relative cursor-pointer z-10'
                                        alt="Profile"
                                    />
                                    <div onClick={() => fileInputRef.current?.click()} className="absolute inset-0 bg-black opacity-0 group-hover:opacity-50 transition-opacity duration-300 rounded-full flex items-center justify-center cursor-pointer z-20">
                                        <MdAddCircle className='fill-white w-[30%] h-[30%]' />
                                        <input
                                            type="file"
                                            className="hidden"
                                            ref={fileInputRef}
                                            required={required}
                                            onChange={handleFileChange}
                                        />

                                    </div>
                                </div>
                                <div className='mt-4 grid grid-cols-2 gap-4'>
                                    <div className="order-2">
                                        <button className="bg-white text-primary-500 p-2 w-full mt-5 border  rounded-md border-primary-500 md:w-[158px] hover:bg-primary-500 hover:text-white hover:border-transparent transition-all duration-500" onClick={handleContinue}>
                                            {role == "trainee" && !img ? "تخطي" : "استكمال"}
                                        </button>
                                    </div>
                                    <div className="order-1">
                                        <button className="bg-delete bg-opacity-[14.9%] text-red-100 p-2 w-full mt-5 border  rounded-md md:w-[158px] font-[600] hover:bg-red-100 hover:text-white  transition-all duration-500 cursor-pointer" onClick={() => setImg(null)}>
                                            ازاله الصورة
                                        </button>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default ChooseImage